<ejs-dialog #collectionsDialog [isModal]="true" [showCloseIcon]="true" [visible]="false" (close)="onCancel()">
  <ng-template #header>
    {{'i18n.domain.assets.asset-collections.link-asset-collection.dialog.title' | translate}}
  </ng-template>

  <ng-template #content>
    <div class="form-row row">
      <div class="col-12">
        <ejs-grid #grid class="grid-with-toolbar" width="100%" rowHeight="38" [dataSource]="allCollections"
          [allowSorting]="true" [allowFiltering]="true" [filterSettings]='filterSettings' [allowPaging]="false" [editSettings]="customEditSettings"
          (rowDataBound)="onRowDataBound($event)">
          <e-columns>
            <e-column field='id' [visible]='false' [isPrimaryKey]='true'></e-column>
            <e-column field='name' headerText="{{'i18n.domain.assets.asset-collections.name' | translate}}"
              clipMode='EllipsisWithTooltip' type="string">
            </e-column>
            <e-column field='isShared' headerText="{{'i18n.domain.assets.asset-collections.shared' | translate}}"
              clipMode='EllipsisWithTooltip' type="boolean" [allowFiltering]="false">
              <ng-template #template let-data>
                @if(data.isShared){
                  <div class="e-icons icon-checkmark align-middle"></div>
                }
              </ng-template>
            </e-column>
            <e-column field='sharedUntilDate'
              headerText="{{'i18n.domain.assets.asset-collections.shared-until' | translate}}"
              clipMode='EllipsisWithTooltip' type="date" format="dd.MM.yyyy">
            </e-column>
            <e-column field='createdBy' headerText="{{'i18n.domain.assets.asset-collections.created-by' | translate}}"
              clipMode='EllipsisWithTooltip' type="string">
            </e-column>
            <e-column
              headerText="{{'i18n.domain.assets.asset-collections.link-asset-collection.grid.column-headers.link-asset' | translate}}"
              width='150px'>
              <ng-template #template let-data>
                <input type="checkbox" (change)="onCheckboxChange($event, data)" />
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-flat" (click)="onCancel()">
        {{'i18n.shared.cancel' | translate}}
      </button>
      <button class="e-control e-btn e-lib e-primary e-flat" (click)="onSave()" [disabled]="isSaveDisabled">
        {{'i18n.shared.save' | translate}}
      </button>
    </ng-container>
  </ng-template>
</ejs-dialog>
